import { getPageStaticProps } from "@/lib/controllers/page"
import PageView from "@/lib/views/page"

export const getStaticProps = getPageStaticProps
export default PageView
